const state = {
  messageList: {},
  totalMessageList: []
}
const	getters = {
  getMessageList: state => {
    return state.messageList;
  },
  getTotalMessageList: state => {
    return state.totalMessageList;
  }
}
const	mutations = {
  setMessageList(state, payload) {
    state.messageList = payload;
  },
  setTotalMessageList(state, payload) {
    state.totalMessageList = payload;
  },
}
const	actions = {

  reqMessageList( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmMessageCenter/Getlist",
        method: "get",
        params: params,
      }).then((res) => {
        commit('setMessageList', res.data);
        r();
      }).catch(() => {
        j();
      })
    })
  },

  reqTotalMessageList( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmMessageCenter/GetNotReadlist",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        commit('setTotalMessageList', res.data);
        r();
      }).catch(() => {
        j();
      })
    })
  },

  reqReadMessage( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmMessageCenter/Read",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqDeleteMessage( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmMessageCenter/Delete",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },

  reqMessageDetail( { commit }, params ) {
    return new Promise((r, j) => {
      fetch({
        url: "hcm/hcmMessageCenter/Detail",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "json"
      }).then((res) => {
        r(res);
      }).catch(() => {
        j();
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}